import { Box } from "@mui/material";

type RuleGraphLaneDotState = "default" | "filled" | "pending";

export const RuleGraphLaneDot = ({
  state = "default",
}: {
  state?: RuleGraphLaneDotState;
}) => (
  <Box
    aria-hidden="true"
    data-state={state}
    sx={(theme) => ({
      backgroundColor:
        state === "filled"
          ? theme.palette.text.interactive.neutral.default
          : theme.igBackgroundColors.baseLightLow,
      border: `2px solid ${
        state === "filled"
          ? theme.palette.text.interactive.neutral.default
          : theme.igBackgroundColors.interactive.dark.disabled
      }`,

      borderRadius: "50%",
      boxSizing: "border-box",
      // The dot is a flex child of a row that can hold wide condition chips;
      // without this it is squeezed into an ellipse.
      flexShrink: 0,
      height: 9,
      opacity: state === "pending" ? 0.35 : 1,
      width: 9,
    })}
  />
);
